import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'rk-share-bottom-action',
  template: `
    <div class="container">
      <div class="bottom-part flex justify-between">
        <rk-button
          (click)="save.next($event)"
          [label]="buttonLabel || ('SHARE.FORM.GENERATE' | translate)"
          data-cy="submitShare"
        ></rk-button>
        <rk-button
          *ngIf="rightLabel"
          btnStyle="link"
          (click)="rightAction.next($event)"
          [label]="rightLabel"
        ></rk-button>
      </div>
    </div>
  `,
  styleUrls: ['./share-bottom-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareBottomActionComponent {
  @Output()
  readonly save = new EventEmitter();

  @Input()
  buttonLabel: string;

  @Input()
  rightLabel: string;

  @Output()
  readonly rightAction = new EventEmitter();
}
